/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchProgramEventOperation,
    BatchProgramEventOperationFromJSON,
    BatchProgramEventOperationToJSON,
    BatchProgramEventSeriesOperation,
    BatchProgramEventSeriesOperationFromJSON,
    BatchProgramEventSeriesOperationToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    Gender,
    GenderFromJSON,
    GenderToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    ProgramEvent,
    ProgramEventFromJSON,
    ProgramEventToJSON,
    ProgramEventBulkParams,
    ProgramEventBulkParamsFromJSON,
    ProgramEventBulkParamsToJSON,
    ProgramEventCreateParams,
    ProgramEventCreateParamsFromJSON,
    ProgramEventCreateParamsToJSON,
    ProgramEventDuplicateParams,
    ProgramEventDuplicateParamsFromJSON,
    ProgramEventDuplicateParamsToJSON,
    ProgramEventExpandableType,
    ProgramEventExpandableTypeFromJSON,
    ProgramEventExpandableTypeToJSON,
    ProgramEventList,
    ProgramEventListFromJSON,
    ProgramEventListToJSON,
    ProgramEventPatchParams,
    ProgramEventPatchParamsFromJSON,
    ProgramEventPatchParamsToJSON,
    ProgramEventSeries,
    ProgramEventSeriesFromJSON,
    ProgramEventSeriesToJSON,
    ProgramEventSeriesList,
    ProgramEventSeriesListFromJSON,
    ProgramEventSeriesListToJSON,
    ProgramEventStatus,
    ProgramEventStatusFromJSON,
    ProgramEventStatusToJSON,
    ProgramEventTagCreateParams,
    ProgramEventTagCreateParamsFromJSON,
    ProgramEventTagCreateParamsToJSON,
    ProgramEventType,
    ProgramEventTypeFromJSON,
    ProgramEventTypeToJSON,
    ProgramEventUpdateParams,
    ProgramEventUpdateParamsFromJSON,
    ProgramEventUpdateParamsToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    TagList,
    TagListFromJSON,
    TagListToJSON,
    Venue,
    VenueFromJSON,
    VenueToJSON,
    VenueList,
    VenueListFromJSON,
    VenueListToJSON,
} from '../models';

export interface CancelBulkProgramEventRequest {
    program_id: string;
    ProgramEventBulkParams: ProgramEventBulkParams;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    gender?: Array<Gender>;
    venue_id?: Array<string>;
    venue_context?: Array<string>;
    venue_city?: Array<string>;
    online_event?: boolean;
    status?: Array<ProgramEventStatus>;
    type?: Array<ProgramEventType>;
    tags?: Array<string>;
    is_series?: boolean;
    is_appointment?: boolean;
    is_full?: boolean;
    on_sale?: boolean;
    capacity_lt?: number;
    capacity_gt?: number;
    capacity_lte?: number;
    capacity_gte?: number;
    total_registrations_lt?: number;
    total_registrations_gt?: number;
    total_registrations_lte?: number;
    total_registrations_gte?: number;
    sales_gross_lt?: number;
    sales_gross_gt?: number;
    sales_gross_lte?: number;
    sales_gross_gte?: number;
    sales_net_lt?: number;
    sales_net_gt?: number;
    sales_net_lte?: number;
    sales_net_gte?: number;
    published_lt?: Date;
    published_gt?: Date;
    published_lte?: Date;
    published_gte?: Date;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface CancelProgramEventRequest {
    program_id: string;
    event_id: string;
}

export interface CreateBulkProgramEventSeriesRequest {
    event_id: string;
    ProgramEventSeries: Array<ProgramEventSeries>;
}

export interface CreateProgramEventRequest {
    program_id: string;
    ProgramEventCreateParams: ProgramEventCreateParams;
}

export interface CreateProgramEventSeriesRequest {
    event_id: string;
    ProgramEventSeries: ProgramEventSeries;
}

export interface CreateProgramEventTagRequest {
    program_id: string;
    ProgramEventTagCreateParams: ProgramEventTagCreateParams;
}

export interface DeleteBulkProgramEventRequest {
    program_id: string;
    ProgramEventBulkParams: ProgramEventBulkParams;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    gender?: Array<Gender>;
    venue_id?: Array<string>;
    venue_context?: Array<string>;
    venue_city?: Array<string>;
    online_event?: boolean;
    status?: Array<ProgramEventStatus>;
    type?: Array<ProgramEventType>;
    tags?: Array<string>;
    is_series?: boolean;
    is_appointment?: boolean;
    is_full?: boolean;
    on_sale?: boolean;
    capacity_lt?: number;
    capacity_gt?: number;
    capacity_lte?: number;
    capacity_gte?: number;
    total_registrations_lt?: number;
    total_registrations_gt?: number;
    total_registrations_lte?: number;
    total_registrations_gte?: number;
    sales_gross_lt?: number;
    sales_gross_gt?: number;
    sales_gross_lte?: number;
    sales_gross_gte?: number;
    sales_net_lt?: number;
    sales_net_gt?: number;
    sales_net_lte?: number;
    sales_net_gte?: number;
    published_lt?: Date;
    published_gt?: Date;
    published_lte?: Date;
    published_gte?: Date;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface DeleteProgramEventRequest {
    program_id: string;
    event_id: string;
}

export interface DeleteProgramEventSeriesRequest {
    event_id: string;
    id: string;
}

export interface DeleteProgramEventTagRequest {
    program_id: string;
    value: string;
}

export interface DuplicateProgramEventRequest {
    program_id: string;
    event_id: string;
    ProgramEventDuplicateParams: ProgramEventDuplicateParams;
}

export interface FindOneProgramEventRequest {
    program_id: string;
    event_id: string;
    expand?: Array<ProgramEventExpandableType>;
}

export interface FindOneProgramEventSeriesRequest {
    event_id: string;
    id: string;
}

export interface FindOneVenueRequest {
    program_id: string;
    id: string;
}

export interface FindProgramEventSeriessRequest {
    event_id: string;
}

export interface FindProgramEventTagsRequest {
    program_id: string;
    search?: string;
    value?: Array<string>;
    exclude_value?: Array<string>;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindProgramEventsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    gender?: Array<Gender>;
    venue_id?: Array<string>;
    venue_context?: Array<string>;
    venue_city?: Array<string>;
    online_event?: boolean;
    status?: Array<ProgramEventStatus>;
    type?: Array<ProgramEventType>;
    tags?: Array<string>;
    is_series?: boolean;
    is_appointment?: boolean;
    is_full?: boolean;
    on_sale?: boolean;
    capacity_lt?: number;
    capacity_gt?: number;
    capacity_lte?: number;
    capacity_gte?: number;
    total_registrations_lt?: number;
    total_registrations_gt?: number;
    total_registrations_lte?: number;
    total_registrations_gte?: number;
    sales_gross_lt?: number;
    sales_gross_gt?: number;
    sales_gross_lte?: number;
    sales_gross_gte?: number;
    sales_net_lt?: number;
    sales_net_gt?: number;
    sales_net_lte?: number;
    sales_net_gte?: number;
    published_lt?: Date;
    published_gt?: Date;
    published_lte?: Date;
    published_gte?: Date;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindVenuesRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
    status?: Array<ProgramEventStatus>;
    distinct_cities?: boolean;
}

export interface PatchBulkProgramEventRequest {
    program_id: string;
    ProgramEventBulkParams: ProgramEventBulkParams;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    gender?: Array<Gender>;
    venue_id?: Array<string>;
    venue_context?: Array<string>;
    venue_city?: Array<string>;
    online_event?: boolean;
    status?: Array<ProgramEventStatus>;
    type?: Array<ProgramEventType>;
    tags?: Array<string>;
    is_series?: boolean;
    is_appointment?: boolean;
    is_full?: boolean;
    on_sale?: boolean;
    capacity_lt?: number;
    capacity_gt?: number;
    capacity_lte?: number;
    capacity_gte?: number;
    total_registrations_lt?: number;
    total_registrations_gt?: number;
    total_registrations_lte?: number;
    total_registrations_gte?: number;
    sales_gross_lt?: number;
    sales_gross_gt?: number;
    sales_gross_lte?: number;
    sales_gross_gte?: number;
    sales_net_lt?: number;
    sales_net_gt?: number;
    sales_net_lte?: number;
    sales_net_gte?: number;
    published_lt?: Date;
    published_gt?: Date;
    published_lte?: Date;
    published_gte?: Date;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface PatchProgramEventRequest {
    program_id: string;
    event_id: string;
    ProgramEventPatchParams: ProgramEventPatchParams;
}

export interface PublishBulkProgramEventRequest {
    program_id: string;
    ProgramEventBulkParams: ProgramEventBulkParams;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    gender?: Array<Gender>;
    venue_id?: Array<string>;
    venue_context?: Array<string>;
    venue_city?: Array<string>;
    online_event?: boolean;
    status?: Array<ProgramEventStatus>;
    type?: Array<ProgramEventType>;
    tags?: Array<string>;
    is_series?: boolean;
    is_appointment?: boolean;
    is_full?: boolean;
    on_sale?: boolean;
    capacity_lt?: number;
    capacity_gt?: number;
    capacity_lte?: number;
    capacity_gte?: number;
    total_registrations_lt?: number;
    total_registrations_gt?: number;
    total_registrations_lte?: number;
    total_registrations_gte?: number;
    sales_gross_lt?: number;
    sales_gross_gt?: number;
    sales_gross_lte?: number;
    sales_gross_gte?: number;
    sales_net_lt?: number;
    sales_net_gt?: number;
    sales_net_lte?: number;
    sales_net_gte?: number;
    published_lt?: Date;
    published_gt?: Date;
    published_lte?: Date;
    published_gte?: Date;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface PublishProgramEventRequest {
    program_id: string;
    event_id: string;
}

export interface UnpublishBulkProgramEventRequest {
    program_id: string;
    ProgramEventBulkParams: ProgramEventBulkParams;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    gender?: Array<Gender>;
    venue_id?: Array<string>;
    venue_context?: Array<string>;
    venue_city?: Array<string>;
    online_event?: boolean;
    status?: Array<ProgramEventStatus>;
    type?: Array<ProgramEventType>;
    tags?: Array<string>;
    is_series?: boolean;
    is_appointment?: boolean;
    is_full?: boolean;
    on_sale?: boolean;
    capacity_lt?: number;
    capacity_gt?: number;
    capacity_lte?: number;
    capacity_gte?: number;
    total_registrations_lt?: number;
    total_registrations_gt?: number;
    total_registrations_lte?: number;
    total_registrations_gte?: number;
    sales_gross_lt?: number;
    sales_gross_gt?: number;
    sales_gross_lte?: number;
    sales_gross_gte?: number;
    sales_net_lt?: number;
    sales_net_gt?: number;
    sales_net_lte?: number;
    sales_net_gte?: number;
    published_lt?: Date;
    published_gt?: Date;
    published_lte?: Date;
    published_gte?: Date;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface UnpublishProgramEventRequest {
    program_id: string;
    event_id: string;
}

export interface UpdateProgramEventRequest {
    program_id: string;
    event_id: string;
    ProgramEventUpdateParams: ProgramEventUpdateParams;
}

export interface UpdateProgramEventSeriesRequest {
    event_id: string;
    id: string;
    ProgramEventSeries: ProgramEventSeries;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Cancel events in bulk
     */
    async cancelBulkProgramEventRaw(requestParameters: CancelBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramEventOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling cancelBulkProgramEvent.');
        }

        if (requestParameters.ProgramEventBulkParams === null || requestParameters.ProgramEventBulkParams === undefined) {
            throw new runtime.RequiredError('ProgramEventBulkParams','Required parameter requestParameters.ProgramEventBulkParams was null or undefined when calling cancelBulkProgramEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.venue_id) {
            queryParameters['venue_id'] = requestParameters.venue_id;
        }

        if (requestParameters.venue_context) {
            queryParameters['venue_context'] = requestParameters.venue_context;
        }

        if (requestParameters.venue_city) {
            queryParameters['venue_city'] = requestParameters.venue_city;
        }

        if (requestParameters.online_event !== undefined) {
            queryParameters['online_event'] = requestParameters.online_event;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.is_series !== undefined) {
            queryParameters['is_series'] = requestParameters.is_series;
        }

        if (requestParameters.is_appointment !== undefined) {
            queryParameters['is_appointment'] = requestParameters.is_appointment;
        }

        if (requestParameters.is_full !== undefined) {
            queryParameters['is_full'] = requestParameters.is_full;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        if (requestParameters.capacity_lt !== undefined) {
            queryParameters['capacity_lt'] = requestParameters.capacity_lt;
        }

        if (requestParameters.capacity_gt !== undefined) {
            queryParameters['capacity_gt'] = requestParameters.capacity_gt;
        }

        if (requestParameters.capacity_lte !== undefined) {
            queryParameters['capacity_lte'] = requestParameters.capacity_lte;
        }

        if (requestParameters.capacity_gte !== undefined) {
            queryParameters['capacity_gte'] = requestParameters.capacity_gte;
        }

        if (requestParameters.total_registrations_lt !== undefined) {
            queryParameters['total_registrations_lt'] = requestParameters.total_registrations_lt;
        }

        if (requestParameters.total_registrations_gt !== undefined) {
            queryParameters['total_registrations_gt'] = requestParameters.total_registrations_gt;
        }

        if (requestParameters.total_registrations_lte !== undefined) {
            queryParameters['total_registrations_lte'] = requestParameters.total_registrations_lte;
        }

        if (requestParameters.total_registrations_gte !== undefined) {
            queryParameters['total_registrations_gte'] = requestParameters.total_registrations_gte;
        }

        if (requestParameters.sales_gross_lt !== undefined) {
            queryParameters['sales_gross_lt'] = requestParameters.sales_gross_lt;
        }

        if (requestParameters.sales_gross_gt !== undefined) {
            queryParameters['sales_gross_gt'] = requestParameters.sales_gross_gt;
        }

        if (requestParameters.sales_gross_lte !== undefined) {
            queryParameters['sales_gross_lte'] = requestParameters.sales_gross_lte;
        }

        if (requestParameters.sales_gross_gte !== undefined) {
            queryParameters['sales_gross_gte'] = requestParameters.sales_gross_gte;
        }

        if (requestParameters.sales_net_lt !== undefined) {
            queryParameters['sales_net_lt'] = requestParameters.sales_net_lt;
        }

        if (requestParameters.sales_net_gt !== undefined) {
            queryParameters['sales_net_gt'] = requestParameters.sales_net_gt;
        }

        if (requestParameters.sales_net_lte !== undefined) {
            queryParameters['sales_net_lte'] = requestParameters.sales_net_lte;
        }

        if (requestParameters.sales_net_gte !== undefined) {
            queryParameters['sales_net_gte'] = requestParameters.sales_net_gte;
        }

        if (requestParameters.published_lt !== undefined) {
            queryParameters['published_lt'] = (requestParameters.published_lt as any).toISOString();
        }

        if (requestParameters.published_gt !== undefined) {
            queryParameters['published_gt'] = (requestParameters.published_gt as any).toISOString();
        }

        if (requestParameters.published_lte !== undefined) {
            queryParameters['published_lte'] = (requestParameters.published_lte as any).toISOString();
        }

        if (requestParameters.published_gte !== undefined) {
            queryParameters['published_gte'] = (requestParameters.published_gte as any).toISOString();
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/cancel`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventBulkParamsToJSON(requestParameters.ProgramEventBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramEventOperationFromJSON(jsonValue));
    }

    /**
     * Cancel events in bulk
     */
    async cancelBulkProgramEvent(requestParameters: CancelBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramEventOperation> {
        const response = await this.cancelBulkProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel an event for program
     */
    async cancelProgramEventRaw(requestParameters: CancelProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEvent>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling cancelProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling cancelProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}/cancel`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventFromJSON(jsonValue));
    }

    /**
     * Cancel an event for program
     */
    async cancelProgramEvent(requestParameters: CancelProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEvent> {
        const response = await this.cancelProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create event series in bulk
     */
    async createBulkProgramEventSeriesRaw(requestParameters: CreateBulkProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramEventSeriesOperation>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling createBulkProgramEventSeries.');
        }

        if (requestParameters.ProgramEventSeries === null || requestParameters.ProgramEventSeries === undefined) {
            throw new runtime.RequiredError('ProgramEventSeries','Required parameter requestParameters.ProgramEventSeries was null or undefined when calling createBulkProgramEventSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/series/bulk`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ProgramEventSeries.map(ProgramEventSeriesToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramEventSeriesOperationFromJSON(jsonValue));
    }

    /**
     * Create event series in bulk
     */
    async createBulkProgramEventSeries(requestParameters: CreateBulkProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramEventSeriesOperation> {
        const response = await this.createBulkProgramEventSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an event for program
     */
    async createProgramEventRaw(requestParameters: CreateProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEvent>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createProgramEvent.');
        }

        if (requestParameters.ProgramEventCreateParams === null || requestParameters.ProgramEventCreateParams === undefined) {
            throw new runtime.RequiredError('ProgramEventCreateParams','Required parameter requestParameters.ProgramEventCreateParams was null or undefined when calling createProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventCreateParamsToJSON(requestParameters.ProgramEventCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventFromJSON(jsonValue));
    }

    /**
     * Create an event for program
     */
    async createProgramEvent(requestParameters: CreateProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEvent> {
        const response = await this.createProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create event series
     */
    async createProgramEventSeriesRaw(requestParameters: CreateProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEventSeries>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling createProgramEventSeries.');
        }

        if (requestParameters.ProgramEventSeries === null || requestParameters.ProgramEventSeries === undefined) {
            throw new runtime.RequiredError('ProgramEventSeries','Required parameter requestParameters.ProgramEventSeries was null or undefined when calling createProgramEventSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/series`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventSeriesToJSON(requestParameters.ProgramEventSeries),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventSeriesFromJSON(jsonValue));
    }

    /**
     * Create event series
     */
    async createProgramEventSeries(requestParameters: CreateProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEventSeries> {
        const response = await this.createProgramEventSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create tag for program
     */
    async createProgramEventTagRaw(requestParameters: CreateProgramEventTagRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createProgramEventTag.');
        }

        if (requestParameters.ProgramEventTagCreateParams === null || requestParameters.ProgramEventTagCreateParams === undefined) {
            throw new runtime.RequiredError('ProgramEventTagCreateParams','Required parameter requestParameters.ProgramEventTagCreateParams was null or undefined when calling createProgramEventTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/event_tags`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventTagCreateParamsToJSON(requestParameters.ProgramEventTagCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Create tag for program
     */
    async createProgramEventTag(requestParameters: CreateProgramEventTagRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.createProgramEventTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete events in bulk
     */
    async deleteBulkProgramEventRaw(requestParameters: DeleteBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramEventOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteBulkProgramEvent.');
        }

        if (requestParameters.ProgramEventBulkParams === null || requestParameters.ProgramEventBulkParams === undefined) {
            throw new runtime.RequiredError('ProgramEventBulkParams','Required parameter requestParameters.ProgramEventBulkParams was null or undefined when calling deleteBulkProgramEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.venue_id) {
            queryParameters['venue_id'] = requestParameters.venue_id;
        }

        if (requestParameters.venue_context) {
            queryParameters['venue_context'] = requestParameters.venue_context;
        }

        if (requestParameters.venue_city) {
            queryParameters['venue_city'] = requestParameters.venue_city;
        }

        if (requestParameters.online_event !== undefined) {
            queryParameters['online_event'] = requestParameters.online_event;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.is_series !== undefined) {
            queryParameters['is_series'] = requestParameters.is_series;
        }

        if (requestParameters.is_appointment !== undefined) {
            queryParameters['is_appointment'] = requestParameters.is_appointment;
        }

        if (requestParameters.is_full !== undefined) {
            queryParameters['is_full'] = requestParameters.is_full;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        if (requestParameters.capacity_lt !== undefined) {
            queryParameters['capacity_lt'] = requestParameters.capacity_lt;
        }

        if (requestParameters.capacity_gt !== undefined) {
            queryParameters['capacity_gt'] = requestParameters.capacity_gt;
        }

        if (requestParameters.capacity_lte !== undefined) {
            queryParameters['capacity_lte'] = requestParameters.capacity_lte;
        }

        if (requestParameters.capacity_gte !== undefined) {
            queryParameters['capacity_gte'] = requestParameters.capacity_gte;
        }

        if (requestParameters.total_registrations_lt !== undefined) {
            queryParameters['total_registrations_lt'] = requestParameters.total_registrations_lt;
        }

        if (requestParameters.total_registrations_gt !== undefined) {
            queryParameters['total_registrations_gt'] = requestParameters.total_registrations_gt;
        }

        if (requestParameters.total_registrations_lte !== undefined) {
            queryParameters['total_registrations_lte'] = requestParameters.total_registrations_lte;
        }

        if (requestParameters.total_registrations_gte !== undefined) {
            queryParameters['total_registrations_gte'] = requestParameters.total_registrations_gte;
        }

        if (requestParameters.sales_gross_lt !== undefined) {
            queryParameters['sales_gross_lt'] = requestParameters.sales_gross_lt;
        }

        if (requestParameters.sales_gross_gt !== undefined) {
            queryParameters['sales_gross_gt'] = requestParameters.sales_gross_gt;
        }

        if (requestParameters.sales_gross_lte !== undefined) {
            queryParameters['sales_gross_lte'] = requestParameters.sales_gross_lte;
        }

        if (requestParameters.sales_gross_gte !== undefined) {
            queryParameters['sales_gross_gte'] = requestParameters.sales_gross_gte;
        }

        if (requestParameters.sales_net_lt !== undefined) {
            queryParameters['sales_net_lt'] = requestParameters.sales_net_lt;
        }

        if (requestParameters.sales_net_gt !== undefined) {
            queryParameters['sales_net_gt'] = requestParameters.sales_net_gt;
        }

        if (requestParameters.sales_net_lte !== undefined) {
            queryParameters['sales_net_lte'] = requestParameters.sales_net_lte;
        }

        if (requestParameters.sales_net_gte !== undefined) {
            queryParameters['sales_net_gte'] = requestParameters.sales_net_gte;
        }

        if (requestParameters.published_lt !== undefined) {
            queryParameters['published_lt'] = (requestParameters.published_lt as any).toISOString();
        }

        if (requestParameters.published_gt !== undefined) {
            queryParameters['published_gt'] = (requestParameters.published_gt as any).toISOString();
        }

        if (requestParameters.published_lte !== undefined) {
            queryParameters['published_lte'] = (requestParameters.published_lte as any).toISOString();
        }

        if (requestParameters.published_gte !== undefined) {
            queryParameters['published_gte'] = (requestParameters.published_gte as any).toISOString();
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventBulkParamsToJSON(requestParameters.ProgramEventBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramEventOperationFromJSON(jsonValue));
    }

    /**
     * Delete events in bulk
     */
    async deleteBulkProgramEvent(requestParameters: DeleteBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramEventOperation> {
        const response = await this.deleteBulkProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an event for program
     */
    async deleteProgramEventRaw(requestParameters: DeleteProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling deleteProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete an event for program
     */
    async deleteProgramEvent(requestParameters: DeleteProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete event series
     */
    async deleteProgramEventSeriesRaw(requestParameters: DeleteProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling deleteProgramEventSeries.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProgramEventSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/series/{id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete event series
     */
    async deleteProgramEventSeries(requestParameters: DeleteProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteProgramEventSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete tag from program
     */
    async deleteProgramEventTagRaw(requestParameters: DeleteProgramEventTagRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteProgramEventTag.');
        }

        if (requestParameters.value === null || requestParameters.value === undefined) {
            throw new runtime.RequiredError('value','Required parameter requestParameters.value was null or undefined when calling deleteProgramEventTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/event_tags/{value}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"value"}}`, encodeURIComponent(String(requestParameters.value))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete tag from program
     */
    async deleteProgramEventTag(requestParameters: DeleteProgramEventTagRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteProgramEventTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Duplicate an event for program
     */
    async duplicateProgramEventRaw(requestParameters: DuplicateProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramEventOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling duplicateProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling duplicateProgramEvent.');
        }

        if (requestParameters.ProgramEventDuplicateParams === null || requestParameters.ProgramEventDuplicateParams === undefined) {
            throw new runtime.RequiredError('ProgramEventDuplicateParams','Required parameter requestParameters.ProgramEventDuplicateParams was null or undefined when calling duplicateProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}/duplicate`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventDuplicateParamsToJSON(requestParameters.ProgramEventDuplicateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramEventOperationFromJSON(jsonValue));
    }

    /**
     * Duplicate an event for program
     */
    async duplicateProgramEvent(requestParameters: DuplicateProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramEventOperation> {
        const response = await this.duplicateProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find program event by id
     */
    async findOneProgramEventRaw(requestParameters: FindOneProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEvent>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findOneProgramEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.expand) {
            queryParameters['expand'] = requestParameters.expand;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventFromJSON(jsonValue));
    }

    /**
     * Find program event by id
     */
    async findOneProgramEvent(requestParameters: FindOneProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEvent> {
        const response = await this.findOneProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find event series by id
     */
    async findOneProgramEventSeriesRaw(requestParameters: FindOneProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEventSeries>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findOneProgramEventSeries.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneProgramEventSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/series/{id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventSeriesFromJSON(jsonValue));
    }

    /**
     * Find event series by id
     */
    async findOneProgramEventSeries(requestParameters: FindOneProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEventSeries> {
        const response = await this.findOneProgramEventSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find venue by id
     */
    async findOneVenueRaw(requestParameters: FindOneVenueRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Venue>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneVenue.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneVenue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/venues/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueFromJSON(jsonValue));
    }

    /**
     * Find venue by id
     */
    async findOneVenue(requestParameters: FindOneVenueRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Venue> {
        const response = await this.findOneVenueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all event series
     */
    async findProgramEventSeriessRaw(requestParameters: FindProgramEventSeriessRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEventSeriesList>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findProgramEventSeriess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/series`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventSeriesListFromJSON(jsonValue));
    }

    /**
     * List all event series
     */
    async findProgramEventSeriess(requestParameters: FindProgramEventSeriessRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEventSeriesList> {
        const response = await this.findProgramEventSeriessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all tags for program
     */
    async findProgramEventTagsRaw(requestParameters: FindProgramEventTagsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<TagList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProgramEventTags.');
        }

        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.value) {
            queryParameters['value'] = requestParameters.value;
        }

        if (requestParameters.exclude_value) {
            queryParameters['exclude_value'] = requestParameters.exclude_value;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/event_tags`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TagListFromJSON(jsonValue));
    }

    /**
     * List all tags for program
     */
    async findProgramEventTags(requestParameters: FindProgramEventTagsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<TagList> {
        const response = await this.findProgramEventTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all program\'s events
     */
    async findProgramEventsRaw(requestParameters: FindProgramEventsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEventList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProgramEvents.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.venue_id) {
            queryParameters['venue_id'] = requestParameters.venue_id;
        }

        if (requestParameters.venue_context) {
            queryParameters['venue_context'] = requestParameters.venue_context;
        }

        if (requestParameters.venue_city) {
            queryParameters['venue_city'] = requestParameters.venue_city;
        }

        if (requestParameters.online_event !== undefined) {
            queryParameters['online_event'] = requestParameters.online_event;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.is_series !== undefined) {
            queryParameters['is_series'] = requestParameters.is_series;
        }

        if (requestParameters.is_appointment !== undefined) {
            queryParameters['is_appointment'] = requestParameters.is_appointment;
        }

        if (requestParameters.is_full !== undefined) {
            queryParameters['is_full'] = requestParameters.is_full;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        if (requestParameters.capacity_lt !== undefined) {
            queryParameters['capacity_lt'] = requestParameters.capacity_lt;
        }

        if (requestParameters.capacity_gt !== undefined) {
            queryParameters['capacity_gt'] = requestParameters.capacity_gt;
        }

        if (requestParameters.capacity_lte !== undefined) {
            queryParameters['capacity_lte'] = requestParameters.capacity_lte;
        }

        if (requestParameters.capacity_gte !== undefined) {
            queryParameters['capacity_gte'] = requestParameters.capacity_gte;
        }

        if (requestParameters.total_registrations_lt !== undefined) {
            queryParameters['total_registrations_lt'] = requestParameters.total_registrations_lt;
        }

        if (requestParameters.total_registrations_gt !== undefined) {
            queryParameters['total_registrations_gt'] = requestParameters.total_registrations_gt;
        }

        if (requestParameters.total_registrations_lte !== undefined) {
            queryParameters['total_registrations_lte'] = requestParameters.total_registrations_lte;
        }

        if (requestParameters.total_registrations_gte !== undefined) {
            queryParameters['total_registrations_gte'] = requestParameters.total_registrations_gte;
        }

        if (requestParameters.sales_gross_lt !== undefined) {
            queryParameters['sales_gross_lt'] = requestParameters.sales_gross_lt;
        }

        if (requestParameters.sales_gross_gt !== undefined) {
            queryParameters['sales_gross_gt'] = requestParameters.sales_gross_gt;
        }

        if (requestParameters.sales_gross_lte !== undefined) {
            queryParameters['sales_gross_lte'] = requestParameters.sales_gross_lte;
        }

        if (requestParameters.sales_gross_gte !== undefined) {
            queryParameters['sales_gross_gte'] = requestParameters.sales_gross_gte;
        }

        if (requestParameters.sales_net_lt !== undefined) {
            queryParameters['sales_net_lt'] = requestParameters.sales_net_lt;
        }

        if (requestParameters.sales_net_gt !== undefined) {
            queryParameters['sales_net_gt'] = requestParameters.sales_net_gt;
        }

        if (requestParameters.sales_net_lte !== undefined) {
            queryParameters['sales_net_lte'] = requestParameters.sales_net_lte;
        }

        if (requestParameters.sales_net_gte !== undefined) {
            queryParameters['sales_net_gte'] = requestParameters.sales_net_gte;
        }

        if (requestParameters.published_lt !== undefined) {
            queryParameters['published_lt'] = (requestParameters.published_lt as any).toISOString();
        }

        if (requestParameters.published_gt !== undefined) {
            queryParameters['published_gt'] = (requestParameters.published_gt as any).toISOString();
        }

        if (requestParameters.published_lte !== undefined) {
            queryParameters['published_lte'] = (requestParameters.published_lte as any).toISOString();
        }

        if (requestParameters.published_gte !== undefined) {
            queryParameters['published_gte'] = (requestParameters.published_gte as any).toISOString();
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventListFromJSON(jsonValue));
    }

    /**
     * List all program\'s events
     */
    async findProgramEvents(requestParameters: FindProgramEventsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEventList> {
        const response = await this.findProgramEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all venues
     */
    async findVenuesRaw(requestParameters: FindVenuesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<VenueList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findVenues.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.distinct_cities !== undefined) {
            queryParameters['distinct_cities'] = requestParameters.distinct_cities;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/venues`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueListFromJSON(jsonValue));
    }

    /**
     * List all venues
     */
    async findVenues(requestParameters: FindVenuesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<VenueList> {
        const response = await this.findVenuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch events in bulk
     */
    async patchBulkProgramEventRaw(requestParameters: PatchBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramEventOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling patchBulkProgramEvent.');
        }

        if (requestParameters.ProgramEventBulkParams === null || requestParameters.ProgramEventBulkParams === undefined) {
            throw new runtime.RequiredError('ProgramEventBulkParams','Required parameter requestParameters.ProgramEventBulkParams was null or undefined when calling patchBulkProgramEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.venue_id) {
            queryParameters['venue_id'] = requestParameters.venue_id;
        }

        if (requestParameters.venue_context) {
            queryParameters['venue_context'] = requestParameters.venue_context;
        }

        if (requestParameters.venue_city) {
            queryParameters['venue_city'] = requestParameters.venue_city;
        }

        if (requestParameters.online_event !== undefined) {
            queryParameters['online_event'] = requestParameters.online_event;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.is_series !== undefined) {
            queryParameters['is_series'] = requestParameters.is_series;
        }

        if (requestParameters.is_appointment !== undefined) {
            queryParameters['is_appointment'] = requestParameters.is_appointment;
        }

        if (requestParameters.is_full !== undefined) {
            queryParameters['is_full'] = requestParameters.is_full;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        if (requestParameters.capacity_lt !== undefined) {
            queryParameters['capacity_lt'] = requestParameters.capacity_lt;
        }

        if (requestParameters.capacity_gt !== undefined) {
            queryParameters['capacity_gt'] = requestParameters.capacity_gt;
        }

        if (requestParameters.capacity_lte !== undefined) {
            queryParameters['capacity_lte'] = requestParameters.capacity_lte;
        }

        if (requestParameters.capacity_gte !== undefined) {
            queryParameters['capacity_gte'] = requestParameters.capacity_gte;
        }

        if (requestParameters.total_registrations_lt !== undefined) {
            queryParameters['total_registrations_lt'] = requestParameters.total_registrations_lt;
        }

        if (requestParameters.total_registrations_gt !== undefined) {
            queryParameters['total_registrations_gt'] = requestParameters.total_registrations_gt;
        }

        if (requestParameters.total_registrations_lte !== undefined) {
            queryParameters['total_registrations_lte'] = requestParameters.total_registrations_lte;
        }

        if (requestParameters.total_registrations_gte !== undefined) {
            queryParameters['total_registrations_gte'] = requestParameters.total_registrations_gte;
        }

        if (requestParameters.sales_gross_lt !== undefined) {
            queryParameters['sales_gross_lt'] = requestParameters.sales_gross_lt;
        }

        if (requestParameters.sales_gross_gt !== undefined) {
            queryParameters['sales_gross_gt'] = requestParameters.sales_gross_gt;
        }

        if (requestParameters.sales_gross_lte !== undefined) {
            queryParameters['sales_gross_lte'] = requestParameters.sales_gross_lte;
        }

        if (requestParameters.sales_gross_gte !== undefined) {
            queryParameters['sales_gross_gte'] = requestParameters.sales_gross_gte;
        }

        if (requestParameters.sales_net_lt !== undefined) {
            queryParameters['sales_net_lt'] = requestParameters.sales_net_lt;
        }

        if (requestParameters.sales_net_gt !== undefined) {
            queryParameters['sales_net_gt'] = requestParameters.sales_net_gt;
        }

        if (requestParameters.sales_net_lte !== undefined) {
            queryParameters['sales_net_lte'] = requestParameters.sales_net_lte;
        }

        if (requestParameters.sales_net_gte !== undefined) {
            queryParameters['sales_net_gte'] = requestParameters.sales_net_gte;
        }

        if (requestParameters.published_lt !== undefined) {
            queryParameters['published_lt'] = (requestParameters.published_lt as any).toISOString();
        }

        if (requestParameters.published_gt !== undefined) {
            queryParameters['published_gt'] = (requestParameters.published_gt as any).toISOString();
        }

        if (requestParameters.published_lte !== undefined) {
            queryParameters['published_lte'] = (requestParameters.published_lte as any).toISOString();
        }

        if (requestParameters.published_gte !== undefined) {
            queryParameters['published_gte'] = (requestParameters.published_gte as any).toISOString();
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventBulkParamsToJSON(requestParameters.ProgramEventBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramEventOperationFromJSON(jsonValue));
    }

    /**
     * Patch events in bulk
     */
    async patchBulkProgramEvent(requestParameters: PatchBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramEventOperation> {
        const response = await this.patchBulkProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an event for program
     */
    async patchProgramEventRaw(requestParameters: PatchProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEvent>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling patchProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling patchProgramEvent.');
        }

        if (requestParameters.ProgramEventPatchParams === null || requestParameters.ProgramEventPatchParams === undefined) {
            throw new runtime.RequiredError('ProgramEventPatchParams','Required parameter requestParameters.ProgramEventPatchParams was null or undefined when calling patchProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventPatchParamsToJSON(requestParameters.ProgramEventPatchParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventFromJSON(jsonValue));
    }

    /**
     * Patch an event for program
     */
    async patchProgramEvent(requestParameters: PatchProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEvent> {
        const response = await this.patchProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish events in bulk
     */
    async publishBulkProgramEventRaw(requestParameters: PublishBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramEventOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling publishBulkProgramEvent.');
        }

        if (requestParameters.ProgramEventBulkParams === null || requestParameters.ProgramEventBulkParams === undefined) {
            throw new runtime.RequiredError('ProgramEventBulkParams','Required parameter requestParameters.ProgramEventBulkParams was null or undefined when calling publishBulkProgramEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.venue_id) {
            queryParameters['venue_id'] = requestParameters.venue_id;
        }

        if (requestParameters.venue_context) {
            queryParameters['venue_context'] = requestParameters.venue_context;
        }

        if (requestParameters.venue_city) {
            queryParameters['venue_city'] = requestParameters.venue_city;
        }

        if (requestParameters.online_event !== undefined) {
            queryParameters['online_event'] = requestParameters.online_event;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.is_series !== undefined) {
            queryParameters['is_series'] = requestParameters.is_series;
        }

        if (requestParameters.is_appointment !== undefined) {
            queryParameters['is_appointment'] = requestParameters.is_appointment;
        }

        if (requestParameters.is_full !== undefined) {
            queryParameters['is_full'] = requestParameters.is_full;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        if (requestParameters.capacity_lt !== undefined) {
            queryParameters['capacity_lt'] = requestParameters.capacity_lt;
        }

        if (requestParameters.capacity_gt !== undefined) {
            queryParameters['capacity_gt'] = requestParameters.capacity_gt;
        }

        if (requestParameters.capacity_lte !== undefined) {
            queryParameters['capacity_lte'] = requestParameters.capacity_lte;
        }

        if (requestParameters.capacity_gte !== undefined) {
            queryParameters['capacity_gte'] = requestParameters.capacity_gte;
        }

        if (requestParameters.total_registrations_lt !== undefined) {
            queryParameters['total_registrations_lt'] = requestParameters.total_registrations_lt;
        }

        if (requestParameters.total_registrations_gt !== undefined) {
            queryParameters['total_registrations_gt'] = requestParameters.total_registrations_gt;
        }

        if (requestParameters.total_registrations_lte !== undefined) {
            queryParameters['total_registrations_lte'] = requestParameters.total_registrations_lte;
        }

        if (requestParameters.total_registrations_gte !== undefined) {
            queryParameters['total_registrations_gte'] = requestParameters.total_registrations_gte;
        }

        if (requestParameters.sales_gross_lt !== undefined) {
            queryParameters['sales_gross_lt'] = requestParameters.sales_gross_lt;
        }

        if (requestParameters.sales_gross_gt !== undefined) {
            queryParameters['sales_gross_gt'] = requestParameters.sales_gross_gt;
        }

        if (requestParameters.sales_gross_lte !== undefined) {
            queryParameters['sales_gross_lte'] = requestParameters.sales_gross_lte;
        }

        if (requestParameters.sales_gross_gte !== undefined) {
            queryParameters['sales_gross_gte'] = requestParameters.sales_gross_gte;
        }

        if (requestParameters.sales_net_lt !== undefined) {
            queryParameters['sales_net_lt'] = requestParameters.sales_net_lt;
        }

        if (requestParameters.sales_net_gt !== undefined) {
            queryParameters['sales_net_gt'] = requestParameters.sales_net_gt;
        }

        if (requestParameters.sales_net_lte !== undefined) {
            queryParameters['sales_net_lte'] = requestParameters.sales_net_lte;
        }

        if (requestParameters.sales_net_gte !== undefined) {
            queryParameters['sales_net_gte'] = requestParameters.sales_net_gte;
        }

        if (requestParameters.published_lt !== undefined) {
            queryParameters['published_lt'] = (requestParameters.published_lt as any).toISOString();
        }

        if (requestParameters.published_gt !== undefined) {
            queryParameters['published_gt'] = (requestParameters.published_gt as any).toISOString();
        }

        if (requestParameters.published_lte !== undefined) {
            queryParameters['published_lte'] = (requestParameters.published_lte as any).toISOString();
        }

        if (requestParameters.published_gte !== undefined) {
            queryParameters['published_gte'] = (requestParameters.published_gte as any).toISOString();
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/publish`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventBulkParamsToJSON(requestParameters.ProgramEventBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramEventOperationFromJSON(jsonValue));
    }

    /**
     * Publish events in bulk
     */
    async publishBulkProgramEvent(requestParameters: PublishBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramEventOperation> {
        const response = await this.publishBulkProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish an event for program
     */
    async publishProgramEventRaw(requestParameters: PublishProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEvent>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling publishProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling publishProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}/publish`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventFromJSON(jsonValue));
    }

    /**
     * Publish an event for program
     */
    async publishProgramEvent(requestParameters: PublishProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEvent> {
        const response = await this.publishProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unpublish events in bulk
     */
    async unpublishBulkProgramEventRaw(requestParameters: UnpublishBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramEventOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling unpublishBulkProgramEvent.');
        }

        if (requestParameters.ProgramEventBulkParams === null || requestParameters.ProgramEventBulkParams === undefined) {
            throw new runtime.RequiredError('ProgramEventBulkParams','Required parameter requestParameters.ProgramEventBulkParams was null or undefined when calling unpublishBulkProgramEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.venue_id) {
            queryParameters['venue_id'] = requestParameters.venue_id;
        }

        if (requestParameters.venue_context) {
            queryParameters['venue_context'] = requestParameters.venue_context;
        }

        if (requestParameters.venue_city) {
            queryParameters['venue_city'] = requestParameters.venue_city;
        }

        if (requestParameters.online_event !== undefined) {
            queryParameters['online_event'] = requestParameters.online_event;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }

        if (requestParameters.is_series !== undefined) {
            queryParameters['is_series'] = requestParameters.is_series;
        }

        if (requestParameters.is_appointment !== undefined) {
            queryParameters['is_appointment'] = requestParameters.is_appointment;
        }

        if (requestParameters.is_full !== undefined) {
            queryParameters['is_full'] = requestParameters.is_full;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        if (requestParameters.capacity_lt !== undefined) {
            queryParameters['capacity_lt'] = requestParameters.capacity_lt;
        }

        if (requestParameters.capacity_gt !== undefined) {
            queryParameters['capacity_gt'] = requestParameters.capacity_gt;
        }

        if (requestParameters.capacity_lte !== undefined) {
            queryParameters['capacity_lte'] = requestParameters.capacity_lte;
        }

        if (requestParameters.capacity_gte !== undefined) {
            queryParameters['capacity_gte'] = requestParameters.capacity_gte;
        }

        if (requestParameters.total_registrations_lt !== undefined) {
            queryParameters['total_registrations_lt'] = requestParameters.total_registrations_lt;
        }

        if (requestParameters.total_registrations_gt !== undefined) {
            queryParameters['total_registrations_gt'] = requestParameters.total_registrations_gt;
        }

        if (requestParameters.total_registrations_lte !== undefined) {
            queryParameters['total_registrations_lte'] = requestParameters.total_registrations_lte;
        }

        if (requestParameters.total_registrations_gte !== undefined) {
            queryParameters['total_registrations_gte'] = requestParameters.total_registrations_gte;
        }

        if (requestParameters.sales_gross_lt !== undefined) {
            queryParameters['sales_gross_lt'] = requestParameters.sales_gross_lt;
        }

        if (requestParameters.sales_gross_gt !== undefined) {
            queryParameters['sales_gross_gt'] = requestParameters.sales_gross_gt;
        }

        if (requestParameters.sales_gross_lte !== undefined) {
            queryParameters['sales_gross_lte'] = requestParameters.sales_gross_lte;
        }

        if (requestParameters.sales_gross_gte !== undefined) {
            queryParameters['sales_gross_gte'] = requestParameters.sales_gross_gte;
        }

        if (requestParameters.sales_net_lt !== undefined) {
            queryParameters['sales_net_lt'] = requestParameters.sales_net_lt;
        }

        if (requestParameters.sales_net_gt !== undefined) {
            queryParameters['sales_net_gt'] = requestParameters.sales_net_gt;
        }

        if (requestParameters.sales_net_lte !== undefined) {
            queryParameters['sales_net_lte'] = requestParameters.sales_net_lte;
        }

        if (requestParameters.sales_net_gte !== undefined) {
            queryParameters['sales_net_gte'] = requestParameters.sales_net_gte;
        }

        if (requestParameters.published_lt !== undefined) {
            queryParameters['published_lt'] = (requestParameters.published_lt as any).toISOString();
        }

        if (requestParameters.published_gt !== undefined) {
            queryParameters['published_gt'] = (requestParameters.published_gt as any).toISOString();
        }

        if (requestParameters.published_lte !== undefined) {
            queryParameters['published_lte'] = (requestParameters.published_lte as any).toISOString();
        }

        if (requestParameters.published_gte !== undefined) {
            queryParameters['published_gte'] = (requestParameters.published_gte as any).toISOString();
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/unpublish`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventBulkParamsToJSON(requestParameters.ProgramEventBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramEventOperationFromJSON(jsonValue));
    }

    /**
     * Unpublish events in bulk
     */
    async unpublishBulkProgramEvent(requestParameters: UnpublishBulkProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramEventOperation> {
        const response = await this.unpublishBulkProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unpublish an event for program
     */
    async unpublishProgramEventRaw(requestParameters: UnpublishProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEvent>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling unpublishProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling unpublishProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}/unpublish`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventFromJSON(jsonValue));
    }

    /**
     * Unpublish an event for program
     */
    async unpublishProgramEvent(requestParameters: UnpublishProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEvent> {
        const response = await this.unpublishProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an event for program
     */
    async updateProgramEventRaw(requestParameters: UpdateProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEvent>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateProgramEvent.');
        }

        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling updateProgramEvent.');
        }

        if (requestParameters.ProgramEventUpdateParams === null || requestParameters.ProgramEventUpdateParams === undefined) {
            throw new runtime.RequiredError('ProgramEventUpdateParams','Required parameter requestParameters.ProgramEventUpdateParams was null or undefined when calling updateProgramEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/events/{event_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventUpdateParamsToJSON(requestParameters.ProgramEventUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventFromJSON(jsonValue));
    }

    /**
     * Update an event for program
     */
    async updateProgramEvent(requestParameters: UpdateProgramEventRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEvent> {
        const response = await this.updateProgramEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update event series
     */
    async updateProgramEventSeriesRaw(requestParameters: UpdateProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramEventSeries>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling updateProgramEventSeries.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProgramEventSeries.');
        }

        if (requestParameters.ProgramEventSeries === null || requestParameters.ProgramEventSeries === undefined) {
            throw new runtime.RequiredError('ProgramEventSeries','Required parameter requestParameters.ProgramEventSeries was null or undefined when calling updateProgramEventSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/series/{id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramEventSeriesToJSON(requestParameters.ProgramEventSeries),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramEventSeriesFromJSON(jsonValue));
    }

    /**
     * Update event series
     */
    async updateProgramEventSeries(requestParameters: UpdateProgramEventSeriesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramEventSeries> {
        const response = await this.updateProgramEventSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
